import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { JsonService } from './json.service';
import { LoggerService } from './logger.service';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { SharedService } from './shared.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  public listaProdutos: string[] = [];
  public listaEspecialidade: string[] = [];
  public listaPosologia: string[] = [];
  public listaNomeMedico: Array<any> = [];
  public listaCRM: Array<any> = [];
  public listaEndereco: string[] = [];
	public listaRegiao: string[] = [];
  public fazendoLogin = false;

  private permissionsSubject = new BehaviorSubject<string[]>([]);
  public permissions$ = this.permissionsSubject.asObservable();

  setPermissions(perms: string[]): void {
    this.permissionsSubject.next(perms);
  }

  getPermissions(): string[] {
    return this.permissionsSubject.value;
  }

  constructor(
    private jsonService: JsonService,
    private logger: LoggerService,
    private sharedService: SharedService
  ) {}

  /** Método genérico para carregar listas */
  private loadList<T extends string | any>(
		observable$: Observable<T[]>,
		target: (data: T[]) => void,
		label: string,
		normalize: boolean = true
		) {
		return observable$.pipe(
			map((resp: T[]) =>
			normalize
				? resp.map(item => typeof item === 'string' ? item.toLowerCase() as T : item)
				: resp
			),
			tap((data: T[]) => target(data)),
			catchError(erro => {
			this.logger.error(`Erro ao carregar ${label}`, erro);
			return of([] as T[]); // força o tipo no retorno
			})
		).subscribe();
	}

	loadInitialData() {
		// this.loadProdutos();
		// this.loadEspecialidades();
		// this.loadPosologia();
		// this.loadMedicos();
		// this.loadEndereco();
	}


	isAdmin(): boolean {
		const permissions = this.getPermissions();
		const adminModules = [
			'Parametrizacao FTP', 'Parametrizacao de filas',
			'Parametrización FTP', 'Paremetrización de filas',
			'Paremetrizacao de filas'
		];
		const admin = permissions.length > 0 && adminModules.some(m => permissions.includes(m));
		this.sharedService.setVariavel(admin);
		return admin;
	}

	isAdminGrupo(): boolean {
		const permissions = this.getPermissions();
		return permissions.includes('ADMINISTRADOR DE GRUPO');
	}

	isAdminGlobalGrupo(): boolean {
		const permissions = this.getPermissions();
		return permissions.includes('ADMINISTRADOR GLOBAL');
	}

}
